import React from "react";
import SettingGif from "../../assets/images/Setting.gif";

export default function LoadingModal() {
  return (
    <div className="onboardinLayout LoginLoading">
      <div className="onboardingCard">
        <div className="onboardingCardTopBox"></div>
        <div className="onboardingCardContentBox">
          <div className="headingBox withHeight">
            <h2 className="title">Alright, let's get you started</h2>
            <p className="subText">Please hold</p>
          </div>
          <div className="soloIconBox">
            <img alt="" src={SettingGif} />
          </div>
        </div>
      </div>
    </div>
  );
}
